import React, { useState, useEffect } from 'react';
import apiClient from '../utils/api';
import './WeatherWidget.css'; // We will create this CSS next

const WeatherWidget = ({ location }) => {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      // Check if location exists and has a city property
      // Note: location might be a string ("Kurnool") or object ({city: "Kurnool"}) 
      // based on how you passed it in Profile.js
      const cityName = location.city || location; 

      if (!cityName) {
        setLoading(false);
        return;
      }

      try {
        // CALL YOUR BACKEND HERE
        const response = await apiClient.get('/weather', {
            params: { city: cityName }
        });

        setWeather(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Weather fetch error:", err);
        setError('Unable to load weather');
        setLoading(false);
      }
    };

    fetchWeather();
  }, [location]);

  if (!weather) return null; // Don't show anything if no data yet
  if (loading) return <div className="weather-widget-loading">Loading Weather...</div>;
  if (error) return <div className="weather-widget-error">⛅ Weather unavailable</div>;

  return (
    <div className="weather-widget-card">
      <div className="weather-icon-container">
        {/* Safety check for weather array */}
        {weather.weather && weather.weather[0] && (
            <img 
            src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`} 
            alt={weather.weather[0].description} 
            />
        )}
      </div>
      <div className="weather-info">
        <div className="weather-temp">{Math.round(weather.main.temp)}°C</div>
        <div className="weather-desc">
            {weather.weather[0].main} • {weather.name}
        </div>
        <div className="weather-details">
            Humidity: {weather.main.humidity}%
        </div>
      </div>
    </div>
  );
};

export default WeatherWidget;